<div class="warehouseTableStatus" *ngIf="minimumLoading" role="status">Загружаем минимальные остатки…</div>
<div class="warehouseTableError" *ngIf="minimumError" role="alert">
  <span>{{ minimumError }}</span><button mat-button type="button" color="primary" (click)="loadMinimums()">Повторить</button>
</div>
<div class="warehouseTableError" *ngIf="lotsError" role="alert">
  <span>{{ lotsError }}</span><button mat-button type="button" color="primary" (click)="loadLots()">Повторить</button>
</div>
<div class="warehouseTableScroll">
  <table class="warehouseTable" aria-label="Остатки, резервы, свободный остаток, минимальный запас и закупочные цены по складам">
    <thead>
      <tr>
        <th scope="col">Склад</th>
        <th scope="col" class="quantityColumn">Остаток</th>
        <th scope="col" class="quantityColumn reservationColumn">В резерве</th>
        <th scope="col" class="quantityColumn">Свободно</th>
        <th scope="col" class="minimumColumn">Минимальный остаток</th>
        <th scope="col" class="lotsColumn">Закупка партий, грн/ед.</th>
        <th scope="col">Адрес хранения</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of rows; trackBy: trackWarehouse" [attr.data-warehouse-id]="row.warehouseId">
        <th scope="row" class="warehouseName">{{ row.warehouseName }}</th>
        <td class="quantityColumn">
          <span class="warehouseQuantity" [class.emptyQuantity]="row.quantity <= 0">{{ row.quantity | number:'1.0-3' }}</span>
        </td>
        <td class="quantityColumn reservationColumn">
          <span *ngIf="row.reservedQuantity !== null; else unknownReserved" class="warehouseQuantity reservedQuantity"
            [class.noReservations]="row.reservedQuantity === 0"
            [matTooltip]="'Заказы: ' + (row.customerReservedQuantity | number:'1.0-3') + ' · Перемещения: ' + (row.transferReservedQuantity | number:'1.0-3') + ' · Возвраты поставщику: ' + (row.supplierReturnReservedQuantity | number:'1.0-3')"
            [matTooltipDisabled]="row.customerReservedQuantity === null || row.transferReservedQuantity === null || row.supplierReturnReservedQuantity === null">{{ row.reservedQuantity | number:'1.0-3' }}</span>
          <ng-template #unknownReserved><span class="muted" matTooltip="Нет данных о резервах">—</span></ng-template>
        </td>
        <td class="quantityColumn">
          <span *ngIf="row.freeQuantity !== null; else unknownFree" class="warehouseQuantity"
            [class.emptyQuantity]="row.freeQuantity <= 0">{{ row.freeQuantity | number:'1.0-3' }}</span>
          <ng-template #unknownFree><span class="muted" matTooltip="Нет данных о свободном остатке">—</span></ng-template>
        </td>
        <td class="minimumColumn">
          <div class="minimumControls">
            <mat-form-field appearance="outline" class="minimumInput">
              <input matInput type="number" min="0" max="1000000" step="1" required
                [attr.aria-label]="'Минимальный остаток: ' + row.warehouseName"
                [ngModel]="row.draft" (ngModelChange)="changeDraft(row, $event)"
                [disabled]="row.saving || row.minimumStock === null" (keydown.enter)="save(row)" />
            </mat-form-field>
            <button mat-stroked-button type="button" class="saveMinimum" color="primary"
              [attr.aria-label]="'Сохранить минимум: ' + row.warehouseName"
              [disabled]="row.saving || row.minimumStock === null || !validDraft(row) || row.draft === row.minimumStock"
              (click)="save(row)">{{ row.saving ? 'Сохраняем…' : 'Сохранить' }}</button>
          </div>
          <div class="rowError" *ngIf="row.minimumStock !== null && !validDraft(row)" role="alert">Целое число от 0 до 1 000 000</div>
          <div class="rowError" *ngIf="row.error" role="alert">{{ row.error }}</div>
          <div class="rowSuccess" *ngIf="row.saved" role="status">Сохранено</div>
        </td>
        <td class="lotsColumn">
          <span class="muted" *ngIf="lotsLoading">Загружаем…</span>
          <span class="muted" *ngIf="!lotsLoading && lotsError">Не загружено</span>
          <ng-container *ngIf="!lotsLoading && !lotsError">
            <div class="batchPrices" *ngIf="row.lots.length; else noLots">
              <div class="batchPrice" *ngFor="let lot of row.lots; trackBy: trackLot"
                [matTooltip]="'Партия №' + lot.lotId + ' · ' + (lot.receiptDate | date:'dd.MM.yyyy')">
                <span class="unitCost">{{ lot.unitCost | number:'1.2-2' }}</span>
                <span class="batchQuantity">× {{ lot.remainingQty | number:'1.0-3' }} ед.</span>
              </div>
            </div>
            <ng-template #noLots><span class="muted">{{ row.quantity > 0 ? 'Нет данных о партиях' : '—' }}</span></ng-template>
          </ng-container>
        </td>
        <td>
          <div class="addressControls">
            <div class="cellList" *ngIf="row.cells.length; else legacyCell">
              <span class="cellBadge" *ngFor="let balance of row.cells">{{ balance.code }}: {{ balance.qty | number:'1.0-3' }}</span>
            </div>
            <ng-template #legacyCell><span class="muted">{{ row.legacyCell || '—' }}</span></ng-template>
            <button *ngIf="row.warehouse" mat-icon-button type="button" color="primary" (click)="editStock(row)"
              matTooltip="Адресное хранение" [attr.aria-label]="'Адресное хранение: ' + row.warehouseName"><mat-icon>edit</mat-icon></button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<p class="tableHint">В резерве — заказы, перемещения и возвраты поставщику. Свободно — остаток за вычетом резервов, не меньше 0. 0 в минимальном остатке — минимум не задан. Сохраняйте минимум отдельно для каждого склада. Для каждой партии указаны закупочная цена за единицу и её оставшееся количество.</p>
<p class="warehouseTableStatus" *ngIf="!rows.length && !minimumLoading && !minimumError">Склады отсутствуют.</p>
